// enums
import { SpecialLeaveWeekEnums } from './SpecialLeaveTab.enums';

// libraries
import { AnimatePresence } from 'motion/react';

// hooks
import { useFormContext, useWatch } from 'react-hook-form';
import { useEffect } from 'react';

// types
import { FormValues } from './SpecialLeaveTab.types';
import { SpecialLeaveFieldsProps } from './SpecialLeaveFields.types';
import ScopeSection from './ScopeSection';
import FteSection from './FteSection';
import NominalDutySection from './NominalDutySection';

const SpecialLeaveFields = ({
  isEditable,
  dutyHourTypeOptions,
  handleAddOrUpdateRow,
  customPlbName,
  editingRowId
}: SpecialLeaveFieldsProps) => {
  const { control, setValue } = useFormContext<FormValues>();

  const [
    specialLeaveWeekType,
    specialLeaveProcessAsNegative,
    specialLeavePeriod
  ] = useWatch({
    control,
    name: [
      'specialLeaveWeekType',
      'specialLeaveProcessAsNegative',
      'specialLeavePeriod'
    ]
  });

  useEffect(() => {
    if (!specialLeaveWeekType)
      setValue('specialLeaveWeekType', SpecialLeaveWeekEnums.ALL_DAYS);
    if (!specialLeaveProcessAsNegative)
      setValue('specialLeaveProcessAsNegative', false);
    if (!specialLeavePeriod) setValue('specialLeavePeriod', 'WEEKLY');
  }, [
    specialLeaveWeekType,
    specialLeaveProcessAsNegative,
    specialLeavePeriod,
    setValue
  ]);

  return (
    <AnimatePresence mode="wait">
      <ScopeSection isEditable={isEditable} />
      <FteSection customPlbName={customPlbName} />
      <NominalDutySection
        isEditable={isEditable}
        handleAddOrUpdateRow={handleAddOrUpdateRow}
        editingRowId={editingRowId}
        dutyHourTypeOptions={dutyHourTypeOptions}
      />
    </AnimatePresence>
  );
};

export default SpecialLeaveFields;
